import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
export default {
  fileCheckinUploadService: [
    'runtimeConstant',
    '$filter',
    'webApiSettings',
    'FileUploader',
    'authService',
    function (
      runtimeConstant,
      $filter,
      webApiSettings,
      FileUploader,
      authService
    ) {
      var authData = authService.authentication;
      var isauth = authData.token !== null && authData.token !== '';

      var uploadOptions = {
        queueLimit: 1,
        url: webApiSettings.apiServiceBaseUri + 'revisions/checkin',
        removeAfterUploading: true,
        headers: {
          Authorization: isauth ? 'Bearer ' + authData.token : '',
        },
      };

      var uploader = new FileUploader(uploadOptions);

      function onErrorItem(fileItem, response, status, headers) {
        // eslint-disable-next-line no-console
        console.info('onErrorItem', fileItem, response, status, headers);
        fileItem.isError = true;
        fileItem.isUploaded = false;
      }

      function onWhenAddingFileFailed(item, filter) {
        if (filter.name === 'imageFilter') {
          swal.fire({
            title: $filter('translate')('INVALID FILE FORMAT TITLE'),
            text: $filter('translate')('INVALID FILE FORMAT MESSAGE'),
            icon: 'warning',
            confirmButtonColor: 'red',
          });
        }
      }

      function getUploader() {
        return uploader;
      }

      function run() {
        try {
          var fileUploadServiceFactory = {};

          uploader.onErrorItem = logWrapper(
            onErrorItem,
            runtimeConstant.isDebugServicesInternals
          );
          uploader.onWhenAddingFileFailed = logWrapper(
            onWhenAddingFileFailed,
            runtimeConstant.isDebugServicesInternals
          );
          fileUploadServiceFactory.getUploader = logWrapper(
            getUploader,
            runtimeConstant.isDebugServicesInternals
          );

          return fileUploadServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
